import { useState } from "react";
import SalesReport from "./SalesReport";
import ProfitReport from "./ProfitReport";
import InventoryReport from "./InventoryReport";
import "./Reports.css";

export default function Reports() {
  const [activeTab, setActiveTab] = useState("sales");

  const tabs = [
    { id: "sales", label: "📊 Ventas", icon: "📊" },
    { id: "profit", label: "💰 Ganancias", icon: "💰" },
    { id: "inventory", label: "📦 Inventario", icon: "📦" }
  ];

  return (
    <div className="reports-container">
      {/* Tabs Navigation */}
      <div className="tabs-header">
        <h1 className="page-title">📈 Reportes</h1>
        <div className="tabs-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tabs Content */}
      <div className="tabs-content">
        {activeTab === "sales" && <SalesReport />}
        {activeTab === "profit" && <ProfitReport />}
        {activeTab === "inventory" && <InventoryReport />}
      </div>
    </div>
  );
}